import * as Actions from '../Actions/ChaveActions';
// import _ from '@lodash';

const initialState = {
    data: null,
    error: null,
    warning: null,
    info: null,
    dialog: null
};

const ChaveReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_CHAVES:
            {
                return {
                    ...state,
                    data: action.payload
                };
            }
        case Actions.CHAVE_ERROR:
            {
                return {
                    ...state,
                    error: action.payload
                };
            }
        case Actions.CHAVE_INFO:
            {
                return {
                    ...state,
                    info: action.payload
                };
            }
        case Actions.CHAVE_WARNING:
            {
                return {
                    ...state,
                    warning: action.payload
                };
            }
        case Actions.OPEN_CHAVE_DIALOG:
            {
                return {
                    ...state,
                    dialog: action.payload
                };
            }
        default:
            {
                return state;
            }
    }
};

const reducer = ChaveReducer;
export default reducer;
